import { Injectable } from '@angular/core';
import { config } from 'config';
import { HttpClient } from '@angular/common/http';
import { JwtAuthService } from '../auth/jwt-auth.service';
import { ActivePharmacy } from 'app/shared/models/activePharmacy.model';
@Injectable({
  providedIn: 'root'
})
export class ListPharmaciesService {
  pharmacies
  constructor(private http: HttpClient, private jwtAuth: JwtAuthService) { }

  getPharmacies() {

    let api = 'getListofActivePharmacies'
    if (this.jwtAuth.isBusiness()) {
      api += '?statuses=1,2,3,4,5,6,7&business_id=' + this.jwtAuth.getUser().businessid
    }

    return this.http.get<ActivePharmacy[]>(config.apiUrl + api, {
      headers: {
        'Authorization': `Bearer ${this.jwtAuth.getJwtToken()}`
      }
    })
  }

  getPharmaciesByLocation(id) {
    return this.http.get<any>(config.apiUrl1 + 'getPharmaciesByLocation', {
      params: {
        locationid: id
      }
    })
  }

}
